import { logs } from './fetch';
import { sanitizeRedirectUrl } from '../utils/urlValidation';
import { API_CONFIG, VENDOR_CONFIG, TIMEOUT_CONFIG } from '../config';

const ApiEndPoint = API_CONFIG.ENDPOINTS.API;
const BearerToken = API_CONFIG.BEARER_TOKEN;
const WifiPassword = VENDOR_CONFIG.WIFI_PASSWORD;
  
const setAuthCookie = () => {
  const now = new Date();
  // Set expiry to end of today
  const expires = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
  document.cookie = `authenticated=true; expires=${expires.toUTCString()}; path=/`;
};

function auth_openwifi(data){
        let redirectURL = sanitizeRedirectUrl(data.UserRedirectUrl);

        if (data.auth_domain){
            console.log("session2")
            data.username = (`${data.sessionID}@${VENDOR_CONFIG.AUTH_DOMAINS.SESSION_2}`)
            console.log(data.username)
        } else {
            console.log("session1")
            data.username = (`${data.sessionID}@${VENDOR_CONFIG.AUTH_DOMAINS.SESSION_1}`)
            console.log(data.username)
        }
        let password = WifiPassword;
        let username = data.username;
        let clickEvent = {
            "sessionID": data.sessionID,
            "clientID": data.clientID,
            "button_id": "go_online",
            "button_url": redirectURL,
            "event": "clickEvent",
            "campaign_code": data.targeting.campaign_code
        }
        var AuthUrl = `http://${data.controller_ip}:${data.controller_port}/logon?username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}&userurl=${encodeURIComponent(redirectURL)}`
        logs(clickEvent,data)
        setTimeout(() => {
            window.location.href = AuthUrl;
        }, TIMEOUT_CONFIG.AUTHENTICATION_DELAY);
        

}

function auth_mikrotik(data){
    let redirectURL = sanitizeRedirectUrl(
        data.auth_domain ? data.UserRedirectUrl_2 : data.UserRedirectUrl
    );

    if (data.auth_domain){
        console.log("session2")
        data.username = (`${data.sessionID}@${VENDOR_CONFIG.AUTH_DOMAINS.SESSION_2}`)
        console.log(data.username)
    } else {
        console.log("session1")
        data.username = (`${data.sessionID}@${VENDOR_CONFIG.AUTH_DOMAINS.SESSION_1}`)
        console.log(data.username)
    }
    let password = WifiPassword;
    let username = data.username;
    let clickEvent = {
        "sessionID": data.sessionID,
        "clientID": data.clientID,
        "button_id": "go_online",
        "button_url": redirectURL,
        "event": "clickEvent",
        "campaign_code": data.targeting.campaign_code
    }

    let AuthUrl;
    if(data.firstPath === "fatti"){
        // For fatti path, construct URL carefully
        AuthUrl = `https://${data.secondPath}/portal/${data.thirdPath}/${data.savedRedirect}`
        setAuthCookie()
    }else{
        // Properly encode URL parameters
        AuthUrl = `http://${data.serverAddress}/login?username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}&dst=${encodeURIComponent(redirectURL)}`
    }

    logs(clickEvent,data)
    setTimeout(() => {
        window.location.href = AuthUrl;
    }, TIMEOUT_CONFIG.AUTHENTICATION_DELAY);
}

async function auth_ruckus(data){
    if (data.auth_domain){
        console.log("session2")
        data.username = (`${data.sessionID}@thinkzone2`)
        console.log(data.username)
    } else {
        console.log("session1")
        data.username = (`${data.sessionID}@thinkzone`)
        console.log(data.username)
    }
    console.log(data)
    const response = await fetch(`${ApiEndPoint}/auth/thinkzone/ruckus/session`,{
        method: "POST",
        headers: {
          "Authorization" : `Bearer ${BearerToken}`,
          "Content-Type": "application/json",
          "mode": "no-cors"
        },
        body: JSON.stringify(data)});
  
    if (!response.ok) {
        return {"status": "error"}
    }else{
        return {
            "status": "success"
        }
    }
}

function auth_cambium(data){
    var auth_data = JSON.parse(data)
    console.group()
    console.log("pppppppppppppppppppppppppppppppppppp")
    if (auth_data.auth_domain){
        auth_data.ga_user = (`${auth_data.sessionID}@thinkzone2`)
        auth_data.ga_pass = "98adf11facdace11"
        console.log(auth_data.username)
    } else {
        auth_data.ga_user = (`${auth_data.sessionID}@thinkzone`)
        auth_data.ga_pass = "98adf11facdace11"
        console.log(auth_data.username)
    }
    fetch(`${ApiEndPoint}/auth/thinkzone/cambium/session`,
        {
            method: "POST",
            headers: {
                "Authorization" : `Bearer ${BearerToken}`,
                "Content-Type": "application/json",

            },
            body: JSON.stringify(auth_data)

        }
    ).then(
        response => response.json()
    ).then(
        //result => redirect(data,result)
    )
}

export const Authenticate = async (data,setdata) => {
    //const { data, setdata } = useSessionStore();

    console.group()
    console.log("===========================")
    console.log("This is the authentication section")
    console.log(data)
    async function Auth_Session(){
        if (data.vendor && !data.portal_testing){
            console.log("vendor = " + data.vendor)
            if(data.vendor === "ruckus"){
                let auth_result = await auth_ruckus(data)
                // let auth_result = {
                //     "details":"success"
                // }
                console.log(auth_result)
                setdata({...data,auth_result})
            } else if (data.vendor === "openwifi") {     
                auth_openwifi(data)
            }else if (data.vendor === "cambium"){
                auth_cambium(data)
            }else if (data.vendor === "mikrotik"){
                auth_mikrotik(data) 
            }else {
                console.log("vendor unknown")
            }
        } else { 
                if (data.portal_testing){
                console.log("lsale_testing")
                let auth_result = {
                    "details":"success"
                }
                setdata({...data,auth_result})
                //redirect(data,result)
            } else {
                console.log("authentication failure")
            }
            
        }
    }
    await Auth_Session()
    console.log("===========================")
    console.groupEnd()
}
